import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import bkstApi from "../../common/api";

export default function TagSearchBox(props) {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const [keyword, setKeyword] = useState("");
  const [data, setData] = useState([]);

  const onChange = (e, v) => {
    if (v) {
      props.onSubmit(v);
    }
  };

  useEffect(() => {
    bkstApi("/tags/product").then((res) => {
      setData(res.data.tags);
    });
  }, []);

  return (
    <Autocomplete
      value={keyword}
      openOnFocus={false}
      onChange={onChange}
      options={data}
      filterSelectedOptions
      renderInput={(params) => <TextField {...params} variant="outlined" label="Search by Theme" />}
      freeSolo
      open={open}
      onOpen={() => {
        // only open when in focus and inputValue is not empty
        if (inputValue) {
          setOpen(true);
        }
      }}
      onClose={() => setOpen(false)}
      inputValue={inputValue}
      onInputChange={(e, value, reason) => {
        setInputValue(value);

        // only open when inputValue is not empty after the user typed something
        if (!value) {
          setOpen(false);
        }
      }}
    />
  );
}
